import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';

import { media } from '../../helpers';
import Wrapper from '../../elements/wrapper';
import HomeTopWave from '../../../images/waves/home-top-wave.inline.svg';
import RightArrow from '../../../images/icons/arrow-right.inline.svg';
import HomeBottomWave from '../../../images/waves/home-bottom-wave.inline.svg';

const HomeTopCTAContainer = styled.div`
    background-color: #1c7775;
    .svg-container {
        svg {
            max-width: 100%;
            width: 100%;
            height: auto;

            path {
                fill: #fff;
            }
        }

        &.bottom {
            background-color: #fff;
            svg {
                path {
                    fill: #1c7775;
                }
            }
        }
    }

    .cta-wrapper {
        text-align: center;

        ${media.medium`max-width: 950px;`}
        ${media.large`margin-top: -35vh;padding-bottom: 10vh;`}
        h2 {
            color: #fff;
            font-size: 2.5rem;
            margin: 0 0 20px;
            letter-spacing: -1px;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
            ${media.large`font-size: 4rem;`}
        }

        p {
            color: #fff;
            font-size: 1.3rem;
            line-height: 1.5;
            margin: 0 auto;
            ${media.medium`max-width: 850px;`}
        }

        .btn-container {
            max-width: 350px;
            margin: 50px auto 0;
            a {
                color: #fff;
                font-weight: bold;
                text-decoration: none;
                font-size: 1.3rem;
                background: #f74d33;
                box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                border-radius: 5px;
                text-align: center;
                padding: 25px 20px;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
                text-align: center;
                display: block;

                span {
                    svg {
                        position: relative;
                        top: 4px;
                    }
                }
            }
        }
    }
`;

const HomeTopCTA = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        id
                        home_acf {
                            topCtaSettings {
                                topCtaContent
                                topCtaTitle
                                topCtaButton {
                                    title
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { topCtaSettings } = data.home.edges[0].node.home_acf || {};
    const { topCtaTitle, topCtaContent, topCtaButton } = topCtaSettings || {};
    return (
        <HomeTopCTAContainer>
            <div className="svg-container top">
                <HomeTopWave />
            </div>
            <Wrapper className="cta-wrapper">
                <h2>{topCtaTitle}</h2>
                <p>{topCtaContent}</p>
                <div className="btn-container">
                    {topCtaButton && (
                        <Link to={topCtaButton.url}>
                            <span>{topCtaButton.title} </span>
                        </Link>
                    )}
                </div>
            </Wrapper>
            <div className="svg-container bottom">
                <HomeBottomWave />
            </div>
        </HomeTopCTAContainer>
    );
};

export default HomeTopCTA;
